import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from 'react-bootstrap';


function ModalselectList({ action, dataArray, title, dataselected, section }) {

    const [showModal, setShowModal] = useState(false);

    {/*view branchoffice*/ }
    const view = () => {
        const listItems = dataArray.map((data, index) => (
            <>
               
                <input type="radio" className="btn-check" name="items-branchs" id={data.name + index} onClick={() =>(action(data), setShowModal(false))} />
                <label className="btn-branchs card-title rounded-3  p-2 border border-primary text-center fw-semibold w-100 text-primary" translate='no' role='button'
                    for={data.name + index} >
                    <span> {data.name}</span>
                </label>

            </>
        ));
        return (listItems)
    }



    return (
        <>
          
            <button class="btn-branchs card-title rounded-3  p-1 border border-primary text-center " type='button' onClick={() => (setShowModal(true))}>

                <small class="d-block fw-semibold" role='button'>

                   <i class="uil uil-store-alt"></i> {section}</small>
                <span class="fw-semibold" role='button' >
                    {dataselected}
                </span>
            </button>

            <Modal
                centered
                className='modal-dialog-kk'
                size="md"
                show={showModal}
                onHide={() => setShowModal(false)}>
                <Modal.Body>

                    <div className='idioma-sp position-relative '>
                        <section className="form-signin-sp bg-white border-0">
                            <h2 className="title-main-login  text-center ">      <i class="uil uil-store-alt"></i>{section}</h2>
                            <div className=' pb-4' >
                                <label className="form-label fw-normal text-gray-600">
                                    {title}
                                </label>
                                <div className='branch-wrapper  no-scroll'>
                                    <div className='d-flex flex-column gap-3 p-2 bg-body' >
                                        
                                        {view()}
                                    </div>
                                </div>
                                <div className='d-block text-center mt-3 opacity-50'>
                                    <i class="uil uil-info-circle"></i>
                                    Escoge una de las opciones.
                                </div>
                            </div>
                        </section>
                        <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" onClick={() => (setShowModal(false))} title='Cerrar'>
                                    <i class="uil uil-multiply"></i>
                                    <span class="visually-hidden">Cerrar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalselectList